import { render, staticRenderFns } from "./tercPicker.vue?vue&type=template&id=5f10420e&"
import script from "./tercPicker.vue?vue&type=script&lang=js&"
export * from "./tercPicker.vue?vue&type=script&lang=js&"
import style0 from "./tercPicker.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports